import React from 'react';

export default function PlusIcon(): JSX.Element {
  return (
    <svg
      width="81"
      height="82"
      viewBox="0 0 81 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="40.5" cy="40.6904" r="40.5" fill="#0047D4" />
      <path
        d="M43 27.4404V38.6904H54.25C55.5781 38.6904 56.75 39.8623 56.75 41.1904C56.75 42.5967 55.5781 43.6904 54.25 43.6904H43V54.9404C43 56.3467 41.8281 57.4404 40.5 57.4404C39.0938 57.4404 38 56.3467 38 54.9404V43.6904H26.75C25.3438 43.6904 24.25 42.5967 24.25 41.1904C24.25 39.8623 25.3438 38.6904 26.75 38.6904H38V27.4404C38 26.1123 39.0938 24.9404 40.5 24.9404C41.8281 24.9404 43 26.1123 43 27.4404Z"
        fill="white"
      />
    </svg>
  );
}
